export default __webpack_public_path__ + "static/media/CVC Card.ee6e8162.svg";